module.exports = __webpack_public_path__ + "img/icons/default-avatar-6b39b1ef2ea2925134275f5ed0958013.svg";